import React, { Component } from 'react'
import { storage } from '../../firebase'
import { ref, getDownloadURL } from 'firebase/storage'
import { ControlText, ControlNumber } from '../forms/Controls'
import './PartidosScores.css'

class PartidosScores extends Component {
  constructor (props) {
    super(props)
    this.state = {
      gLocal: this.props.gLocal,
      gVisitante: this.props.gVisitante,
      localLogoUrl: '',
      visitanteLogoUrl: ''
    }
    this.handleGLocal = this.handleGLocal.bind(this)
    this.handleGVisitante = this.handleGVisitante.bind(this)
  }
  componentDidMount () {
    const localRef = ref(storage, `teams/${this.props.localId}.png`)
    getDownloadURL(localRef)
      .then((url) => {
        this.setState({ localLogoUrl: url })
      })
      .catch((err) => {
        console.error('Error al cargar logo local:', err)
      })

    const visitanteRef = ref(storage, `teams/${this.props.visitanteId}.png`)
    getDownloadURL(visitanteRef)
      .then((url) => {
        this.setState({ visitanteLogoUrl: url })
      })
      .catch((err) => {
        console.error('Error al cargar logo visitante:', err)
      })
  }
  handleGLocal (ev) {
    const value = ev.target.value
    this.setState({
      gLocal: value
    })
    this.props.handleGLocal(value, this.props.n)
  }
  handleGVisitante (ev) {
    const value = ev.target.value
    this.setState({
      gVisitante: value
    })
    this.props.handleGVisitante(value, this.props.n)
  }
  render () {
    return (
      <div className='box'>
        <div className='form_group row'>
          <div className='col-xs-6 col-sm-4 col-sm-offset-2'>
            <div className='edit_logo'>
              {this.state.localLogoUrl && (
                <img src={this.state.localLogoUrl} alt={this.props.local + ' Logo'} />
              )}
            </div>
          </div>
          <div className='col-xs-6 col-sm-4 col-sm-offset-2'>
            <div className='edit_logo'>
              {this.state.visitanteLogoUrl && (
                <img src={this.state.visitanteLogoUrl} alt={this.props.visitante + ' Logo'} />
              )}
            </div>
          </div>
        </div>
        <div className='form_group row'>
          <div className='col-sm-2'>
            <label>Local</label>
          </div>
          <div className='col-sm-4'>
            <ControlText
              placeholder='Nombre de equipo'
              disabled
              value={this.props.local}
            />
          </div>
          <div className='col-sm-2'>
            <label>Visitante</label>
          </div>
          <div className='col-sm-4'>
            <ControlText
              placeholder='Nombre de equipo'
              disabled
              value={this.props.visitante}
            />
          </div>
        </div>
        <div className='form_group row'>
          <div className='col-sm-2'>
            <label>Goles Local</label>
          </div>
          <div className='col-sm-4'>
            <ControlNumber
              value={this.state.gLocal}
              onChange={this.handleGLocal}
            />
          </div>
          <div className='col-sm-2'>
            <label>Goles Visitante</label>
          </div>
          <div className='col-sm-4'>
            <ControlNumber
              value={this.state.gVisitante}
              onChange={this.handleGVisitante}
            />
          </div>
        </div>
        <div className='box_footer'>
          <p>{this.props.n + 1}</p>
        </div>
      </div>
    )
  }
}

export default PartidosScores
